import React, { useEffect, useState } from "react";
import patron from "../../assets/members/chief-patron.jpeg";
import api from "../../utils/axios.config";
import {
  MessageSquareQuote,
  User,
  Briefcase,
  Heart,
  Loader2,
} from "lucide-react";

const ChiefPatronMember = () => {
  const [message, setMessage] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleGetMessage = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("patron-message");
      setMessage(data.patronMessage);
    } catch (error) {
      console.error("Failed to fetch patron message:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetMessage();
  }, []);

  // Default message if API fails or no message available
  const defaultMessage = `মানবসেবার প্রকৃত অর্থ তখনই পূর্ণতা পায়, যখন তা হয় নিঃস্বার্থভাবে। ঠিক তেমনি, নিঃস্বার্থ নবজীবন সংগঠন তার জন্মলগ্ন থেকে সমাজের অবহেলিত, বঞ্চিত ও বিপন্ন মানুষদের পাশে দাঁড়িয়ে এক অনন্য দৃষ্টান্ত স্থাপন করে চলেছে। একজন পৃষ্ঠপোষক হিসেবে আমি গর্বের সঙ্গে বলতে পারি, এই সংগঠনের কার্যক্রম কেবলমাত্র সাহায্য প্রদানেই সীমাবদ্ধ নয়, বরং এটি মানুষকে আত্মনির্ভর হতে উদ্বুদ্ধ করে, তাদের জীবনে আশার আলো জ্বালায়।

শিক্ষা, স্বাস্থ্য, খাদ্য ও বাসস্থান—মানব জীবনের এই মৌলিক চাহিদাগুলো পূরণে নিঃস্বার্থ নবজীবন সংগঠন নিরলসভাবে কাজ করছে। সুবিধাবঞ্চিত শিশুদের জন্য স্কুল, পথশিশুদের পুনর্বাসন, গরিব ও অসুস্থ মানুষের চিকিৎসা সহায়তা এবং নারীদের ক্ষমতায়নে যে উদ্যোগ তারা নিয়েছে, তা সত্যিই প্রশংসনীয়।

একজন পৃষ্ঠপোষক হিসেবে আমি শুধু আর্থিকভাবে নয়, মানসিকভাবে এবং আন্তরিকভাবে এই সংগঠনের সঙ্গে যুক্ত আছি। আমি বিশ্বাস করি, আমাদের ক্ষুদ্র সহায়তা হয়তো কারও জীবনে নতুন সূর্যের আলো নিয়ে আসতে পারে।

নিঃস্বার্থ নবজীবন সংগঠনের এই মহৎ যাত্রায় সমাজের সকল স্তরের মানুষকে এগিয়ে আসার আহ্বান জানাই। আসুন, আমরা সবাই মিলে একটি মানবিক, সহানুভূতিশীল ও সুন্দর সমাজ গড়ে তুলি।`;

  return (
    <div className="max-w-6xl mx-auto px-4 mt-20 py-8 bg-gradient-to-b from-primary/5 to-white">
      {/* Header with decorative elements */}
      <div className="text-center mb-8">
        <h1 className="relative inline-block text-3xl md:text-4xl font-bold text-primary mb-2">
          <span className="absolute -left-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <Heart className="h-6 w-6 text-primary" />
          </span>
          প্রধান পৃষ্ঠপোষকের বাণী
          <span className="absolute -right-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <Heart className="h-6 w-6 text-primary" />
          </span>
        </h1>
        <div className="h-1 w-24 bg-primary mx-auto rounded-full"></div>
      </div>

      {/* Card Container */}
      <div className="flex flex-col md:flex-row gap-8 items-stretch">
        {/* Profile Card */}
        <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col border-t-4 border-primary">
          <div className="bg-primary py-4 px-6 text-center">
            <h2 className="text-xl font-semibold text-white flex items-center justify-center">
              <User className="mr-2 h-5 w-5" />
              প্রধান পৃষ্ঠপোষক
            </h2>
          </div>

          <div className="p-6 text-center flex-grow">
            <div className="mb-4 relative">
              <div className="w-40 h-40 mx-auto rounded-full overflow-hidden border-4 border-emerald-100 shadow-md">
                <img
                  src={patron}
                  alt="Chief Patron"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-800 mb-3">
              অরুপ রতন চক্রবর্তী
            </h3>

            <div className="flex items-center justify-center mb-2 text-primary">
              <Briefcase className="h-4 w-4 mr-2" />
              <p className="text-md font-medium">
                বিশিষ্ট ব্যবসায়ী ও সমাজসেবক
              </p>
            </div>

            <div className="rounded-lg p-3 mt-3">
              <p className="text-gray-700 text-sm font-medium">
                প্রধান পৃষ্ঠপোষক
              </p>
              <p className="text-gray-700 text-sm">কেন্দ্রীয় কমিটি</p>
              <p className="text-gray-700 text-sm font-semibold">
                নিঃস্বার্থ নবজীবন সংগঠন - NNS
              </p>
            </div>
          </div>
        </div>

        {/* Message Card */}
        <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col border-t-4 border-primary">
          <div className="bg-primary py-4 px-6">
            <h2 className="text-xl font-semibold text-white flex items-center">
              <MessageSquareQuote className="mr-2 h-5 w-5" />
              প্রধান পৃষ্ঠপোষকের বাণী
            </h2>
          </div>

          <div className="p-6 flex-grow">
            {loading ? (
              <div className="flex items-center justify-center h-full min-h-[200px]">
                <Loader2 className="h-8 w-8 text-primary animate-spin" />
              </div>
            ) : (
              <div className="prose max-w-none text-gray-700 leading-relaxed text-justify">
                <div className="space-y-4 text-sm md:text-base">
                  {message && message[message?.length - 1]?.message
                    ? message[message?.length - 1]?.message
                    : defaultMessage}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChiefPatronMember;
